/** THE SINCE CELL (ported 2026-10-18 from the medrec console's components/list/SinceCell.tsx, its design plan's Lane 1; DESIGN_SYSTEM 7):
 *  how long the row has been in its state, first in the row, 13 px semibold ("57 min", "3 h", "5 d"). RED when it has waited on the team
 *  long enough to be overdue (Sweet Claims' own rule, core queue.ts `ageTone`: over 3 days), the plain ink otherwise; its hover names the
 *  start ("Waiting since Tue 10/13 1:00 pm"). Colour is never alone: the hover and the row's key say it. The medrec console's amber ("the
 *  vendor is late") has no twin on these rows, so it is not drawn. */
export type SinceTone = 'hot' | null;
export function SinceCell({ label, tone, title, className = 'lp-since' }: { label: string; tone: SinceTone; title: string; className?: string }) {
  return (
    <td className={tone === null ? className : `${className} lp-${tone}`} title={title} data-testid="row-since" data-tone={tone ?? undefined}>
      {label}
    </td>
  );
}
